export default __webpack_public_path__ + "static/media/challenge-end.4c4ac420.wav";